/**
 * Created by lk on 17/6/4.
 */
import axios from "axios";
import https from "../../utils/http";
import { getToken, getAdminId } from "../../utils/auth";
let http = https.https;

// 获取列表
export function authAdminList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/admin/index",
        method: "get",
        params: querys
    });
}

// 获取角色列表
export function authAdminRoleList(query) {
    let querys = JSON.parse(JSON.stringify(query));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/admin/roleList",
        method: "get",
        params: querys
    });
}

// 保存
export function authAdminSave(data, formName, method = "post") {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    let url =
        formName === "add"
            ? http + "/auth/admin/save"
            : http + "/auth/admin/edit";
    return axios({
        url: url,
        method: method,
        data: querys
    });
}

// 删除管理员
export function authAdminDelete(data) {
    let querys = JSON.parse(JSON.stringify(data));
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/auth/admin/delete",
        method: "post",
        data: querys
    });
}
